import { useGetCurrentGradeQuery } from '~/curriculum/apis/curriculum.api'

const useGetCurrentUserGrade = () => {
  const { data: currentGradeData, isFetching, isSuccess, refetch } = useGetCurrentGradeQuery()

  return {
    grade: currentGradeData?.grade,
    isFetching,
    isSuccess,
    refetch,
    topicOrder: currentGradeData?.subjectOrder,
  }
}

export default useGetCurrentUserGrade
